import { render, staticRenderFns } from "./RecipientPicker.vue?vue&type=template&id=7036be6a"
import script from "./RecipientPicker.vue?vue&type=script&lang=js"
export * from "./RecipientPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports